import orderBy from "lodash/orderBy";

export const sortNumbersArray = (list, attribute, sortOrder) => {
    const results = orderBy(list, ({metrics}) => metrics[attribute], [sortOrder]); 
    return results;
};

export const sortByNumbers = (list, attribute, sortOrder) => {
    const results = orderBy(list, [attribute],[sortOrder]); 
    return results;
};


export const sortOfficeArray = (list,sortOrder) => {
    const results = orderBy(list, ({office}) => office || 'NA', [sortOrder]); 
    return results;
};

export const sortEnterpriseArray = (list,sortOrder) => {
    const results = orderBy(list, ['organization'], [sortOrder]); 
    return results;   
};

export const sortArray = (list, attribute, sortOrder) => {
    if (sortOrder === 'asc') {
        return list.sort(function (a, b) {
            return (a[attribute] || "|||").toUpperCase().localeCompare((b[attribute] || "|||").toUpperCase())
        });
    } else {
        return list.sort(function (a, b) {
            return (b[attribute] || "!!!").toUpperCase().localeCompare((a[attribute] || "!!!").toUpperCase())
        });
    }
};

export const sortDatesArray = (list, attribute, sortOrder) => {
    const results = orderBy(list, [attribute], [sortOrder]); 
    return results;
};

export const objectEncode = object => {
    return JSON.stringify(object)
};
